import script from "./ClearmentRechnerView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearmentRechnerView.vue?vue&type=script&setup=true&lang=js"

import "./ClearmentRechnerView.vue?vue&type=style&index=0&id=5230e5dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5230e5dc"]])

export default __exports__